<div #bubbleRef class="speech-bubble"
	*ngIf="isAwake && interactive && ( (messageText && messageText.length > 0) || showBubble)"
	[ngClass]="{ 'speech-bubble--thinking': currentFace === 'thinking' }" @bubbleFade>

	<div class="bubble-header" *ngIf="currentFace !='thinking' && messageText">
		<!--	<button class="bubble-volume" (click)="toggleSpeech()">
			<ion-icon [name]="speechEnabled ? 'volume-high' : 'volume-mute'"></ion-icon>
		</button>-->
		<button
			*ngIf="messageText"
			type="button"
			class="bubble-close"
			(click)="closeMiniChat()"
			[attr.aria-label]="'viva-chat-component.aria.close-message' | translate"
		>×</button>
	</div>

	<div *ngIf="showBubble" [innerHTML]="bubbleHintHtml">
	</div>

	<div *ngIf="messageText">
		<div class="bubble-message" [innerHTML]="messageText"></div>

		<div class="bubble-body" *ngIf="showMoreInfoButton">
			<div class="bubble-actions">

				<ion-button
					class="ion-button bubble-action-button"
					color="primary"
					fill="solid"
					(click)="gotoFullChat()"
				>{{moreButtonText}}</ion-button>
			</div>
		</div>
	</div>


	<div *ngIf="currentFace ==='thinking'" class="thinking-indicator">
		<span class="dot"></span>
		<span class="dot"></span>
		<span class="dot"></span>
	</div>

</div>

<!-- the stacked icons -->
<button
	type="button"
	[class.is-visible]="isAwake"
	class="icon-wrapper"
	(click)="botClicked()"
	[attr.aria-label]="'viva-chat-component.aria.open-assistant' | translate"
>
	<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 595.28 581.37">
		<!-- Generator: Adobe Illustrator 29.5.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 141)  -->
		<defs>
			<style>
				.st0 {
					fill-rule: evenodd;
					clip-rule: evenodd;
					fill: var(--viva-chat-bot-outer-fill, #ffffff);
				}

				.st2 {
					fill: var(--viva-chat-bot-background-fill, #0d152d);
					opacity: 0.95;
				}

				.st1 {
					fill-rule: evenodd;
					clip-rule: evenodd;
					fill: var(--viva-chat-bot-inner-fill, #ffffff);
				}
			</style>
		</defs>
		<rect class="st2" x="145.21" y="197.87" width="282.98" height="229.48" rx="49.99" ry="49.99" />
		<g>
			<!--Outer Face-->
			<g>
				<path class="st1"
					d="M475.74,179.95c8.05,0,14.64,6.74,14.64,15.2s-6.59,15.2-14.64,15.2-14.64-6.74-14.64-15.2c.1-8.36,6.59-15.2,14.64-15.2h0ZM354.89,168.88l-11.64,28.49h35.88c27.25,0,49.56,23.15,49.56,51.44v127.65c0,28.29-22.31,51.44-49.56,51.44h-102.8l-9.12,28.59h130.64c34.04,0,61.88-28.89,61.88-64.23v-21.54h6.11c16.49,0,29.97-15.5,29.97-31.21v-47.21c0-13.49-9.99-24.97-23.28-27.78l5.24-47.62c10.77-1.01,19.3-10.37,19.3-21.95,0-12.18-9.5-22.05-21.24-22.05s-21.24,9.87-21.24,22.05c0,9.16,5.43,17.01,13.09,20.33l-5.43,48.52h-2.52v-30.7c0-35.33-27.83-64.23-61.88-64.23,0,0-42.96,0-42.96,0ZM459.73,357.73v-80.33c9.89,0,19.49,6.95,19.49,17.72v41.47c0,11.48-7.47,21.14-19.49,21.14h0Z" />
				<path class="st1"
					d="M98.85,179.95c-8.05,0-14.64,6.74-14.64,15.2s6.59,15.2,14.64,15.2,14.64-6.74,14.64-15.2c0-8.36-6.59-15.2-14.64-15.2h0ZM344.32,168.88h-167.59c-34.04,0-61.88,28.89-61.88,64.23v30.8h-2.52l-5.43-48.52c7.66-3.32,13-11.17,13-20.33,0-12.18-9.5-22.05-21.24-22.05s-21.24,9.87-21.24,22.05c0,11.48,8.44,20.94,19.3,21.95l5.24,47.62c-13.29,2.92-23.28,14.29-23.28,27.78v47.21c0,15.7,13.48,31.21,29.97,31.21h6.11v21.54c0,35.33,27.83,64.23,61.88,64.23h28.42l13.87,34.23,13.09,32.21c.48,1.21,1.55,2.01,2.81,1.91,1.16-.1,2.23-.91,2.62-2.21l10.18-31.91,10.28-32.92,9.02-30h-72.64c-27.25,0-49.56-23.15-49.56-51.44v-127.64c0-28.29,22.31-51.44,49.56-51.44h137.14l12.9-28.49ZM114.86,277.4v80.33c-12.03,0-19.49-9.66-19.49-21.14v-41.47c0-10.77,9.7-17.72,19.49-17.72h0Z" />
			</g>
			<!--Default Happy-->
			<g *ngIf="currentFace==='happy'" #happyFace>
				<path class="st1"
					d="M369.07,277.85c-11.1-20.7-35.2-20.1-48.3-1.3,0,0-7.4-2-8.6-7.3,15.3-26.8,50.5-25.9,65.5.7,0,0,0,5.4-8.6,7.9Z" />
				<path class="st1"
					d="M253.87,277.85c-11.1-20.7-35.2-20.1-48.3-1.3,0,0-7.4-2-8.6-7.3,15.3-26.8,50.5-25.9,65.5.7.1,0,.1,5.4-8.6,7.9Z" />
				<path #animatedPath class="st1"
					d="M238.27,343.05h27.9c.4,0,.7,0,1.1.1,1.4.1,2.7,1,3.3,2.5l6.5,16.1,5.3-16.1c.1-.2.1-.4.2-.5,0-.2.1-.4.2-.6l8.9-26.9c.8-2.3,3.2-3.4,5.4-2.5h0c.6.3,1.1.6,1.6,1.1.6.4,1,1,1.3,1.7l9.3,23h25.7c2.6,0,4.8,2.1,4.8,4.8h0c0,2.6-2.1,4.8-4.8,4.8h-27.9c-.4,0-.7,0-1.1-.1-1.4-.1-2.7-1-3.3-2.5l-6.5-16.1-5.3,16.1c-.1.2-.1.4-.2.5,0,.2-.1.4-.2.6l-8.9,26.9c-.8,2.3-3.2,3.4-5.4,2.5h0c-.6-.3-1.1-.6-1.6-1.1-.6-.4-1-1-1.3-1.7l-9.3-23h-25.7c-2.6,0-4.8-2.1-4.8-4.8h0c0-2.6,2.2-4.8,4.8-4.8Z" />
			</g>
			<g *ngIf="currentFace==='sleep'" #sleepFace>
				<!--Sleeping Zzz-->
				<g>
					<path #animatedPath class="st0"
						d="M436.27,129.96c-2.25,0-4.07-1.84-4.07-4.1s1.82-4.1,4.07-4.1h31.21c2.24,0,4.06,1.84,4.06,4.1,0,1.35-.65,2.55-1.64,3.29l-21.97,19.82h18.91c2.25,0,4.07,1.84,4.07,4.1s-1.82,4.1-4.07,4.1h-29.53v-.02c-1.11,0-2.22-.46-3.02-1.36-1.49-1.68-1.35-4.26.32-5.77l22.24-20.07h-20.59,0Z" />
					<path #animatedPath class="st0"
						d="M483.85,97.54c-1.33,0-2.41-1.09-2.41-2.43s1.08-2.43,2.41-2.43h18.47c1.33,0,2.41,1.09,2.41,2.43,0,.8-.38,1.51-.97,1.95l-13,11.73h11.19c1.33,0,2.41,1.09,2.41,2.43s-1.08,2.43-2.41,2.43h-17.48c-.66-.01-1.31-.28-1.78-.82-.88-.99-.8-2.52.19-3.41l13.16-11.88h-12.18,0Z" />
					<path #animatedPath class="st0"
						d="M517.97,69.54c-.76,0-1.37-.62-1.37-1.38s.61-1.38,1.37-1.38h10.53c.76,0,1.37.62,1.37,1.38,0,.46-.22.86-.55,1.11l-7.41,6.69h6.38c.76,0,1.37.62,1.37,1.38s-.61,1.38-1.37,1.38h-9.96c-.37,0-.75-.16-1.02-.47-.5-.57-.46-1.44.11-1.95l7.51-6.77h-6.95,0Z" />
				</g>
				<!--Sleeping Face Face-->
				<g>
					<ellipse #animatedPath class="st0" cx="285.06" cy="347.68" rx="24.7" ry="30.27" />
					<path class="st0"
						d="M197.72,255.46c-.03-2.78,2.17-5.05,4.92-5.08,2.75-.03,5.01,2.19,5.04,4.97,0,.06.05,20.06,15.29,20.27,7.98.11,12.6-3.33,15.29-7.42,2.91-4.42,3.84-9.74,4.18-12.51.33-2.76,2.83-4.73,5.57-4.39,2.74.34,4.69,2.85,4.35,5.62-.45,3.63-1.69,10.63-5.78,16.84-4.32,6.55-11.55,12.08-23.73,11.91-25.09-.35-25.13-30.12-25.13-30.21h0Z" />
					<path class="st0"
						d="M322.24,255.46c-.03-2.78,2.17-5.05,4.92-5.08s5.01,2.19,5.04,4.97c0,.06.05,20.06,15.29,20.27,7.98.11,12.6-3.33,15.29-7.42,2.91-4.42,3.84-9.74,4.18-12.51.33-2.76,2.83-4.73,5.57-4.39,2.74.34,4.69,2.85,4.35,5.62-.45,3.63-1.69,10.63-5.78,16.84-4.32,6.55-11.55,12.08-23.73,11.91-25.09-.35-25.13-30.12-25.13-30.21h0Z" />
				</g>
			</g>
			<!--Error Face-->
			<g *ngIf="currentFace==='error'">
				<polygon class="st1"
					points="206.72 248.66 206.72 261.66 240.42 274.96 206.72 288.36 206.72 301.66 255.62 280.66 255.62 269.16 206.72 248.66" />
				<polygon class="st1"
					points="367.92 248.66 367.92 261.66 334.22 274.96 367.92 288.36 367.92 301.66 318.92 280.66 318.92 269.16 367.92 248.66" />
				<path #animatedPath class="st1"
					d="M237.82,343.86h27.9c.4,0,.7,0,1.1.1,1.4.1,2.7,1,3.3,2.5l6.5,16.1,5.3-16.1c.1-.2.1-.4.2-.5,0-.2.1-.4.2-.6l8.9-26.9c.8-2.3,3.2-3.4,5.4-2.5h0c.6.3,1.1.6,1.6,1.1.6.4,1,1,1.3,1.7l9.3,23h25.7c2.6,0,4.8,2.1,4.8,4.8h0c0,2.6-2.1,4.8-4.8,4.8h-27.9c-.4,0-.7,0-1.1-.1-1.4-.1-2.7-1-3.3-2.5l-6.5-16.1-5.3,16.1c-.1.2-.1.4-.2.5,0,.2-.1.4-.2.6l-8.8,27c-.8,2.3-3.2,3.4-5.4,2.5h0c-.6-.3-1.1-.6-1.6-1.1-.6-.4-1-1-1.3-1.7l-9.3-23h-25.7c-2.6,0-4.8-2.1-4.8-4.8h0c-.1-2.7,2.1-4.9,4.7-4.9Z" />
			</g>
			<!--Sad Face-->
			<g *ngIf="currentFace==='sad'">
				<path class="st1" d="M225.92,264.93l43.67-16.64s-.62,11.52-15.58,18.72c0,0-20.21,6.56-28.08-2.08Z" />
				<path class="st1" d="M349.16,264.93l-43.67-16.64s.62,11.52,15.58,18.72c0,0,20.21,6.56,28.08-2.08Z" />
				<path class="st0"
					d="M309.52,299.37c-.02-2.77,2.13-5.03,4.8-5.05,2.67-.02,4.85,2.21,4.87,4.97,0,.04.04,15.38,11.21,15.55,5.93.09,9.35-2.52,11.34-5.61,2.2-3.43,2.9-7.59,3.16-9.77.32-2.76,2.74-4.72,5.4-4.38s4.55,2.85,4.23,5.6c-.37,3.03-1.37,8.87-4.72,14.09-3.56,5.56-9.51,10.24-19.52,10.1-20.73-.3-20.76-25.42-20.76-25.49h0Z" />
				<path class="st0"
					d="M220.08,299.37c-.02-2.77,2.13-5.03,4.8-5.05,2.67-.02,4.85,2.21,4.87,4.97,0,.04.04,15.38,11.21,15.55,5.93.09,9.35-2.52,11.34-5.61,2.2-3.43,2.9-7.59,3.16-9.77.32-2.76,2.74-4.72,5.4-4.38s4.55,2.85,4.23,5.6c-.37,3.03-1.37,8.87-4.72,14.09-3.56,5.56-9.51,10.24-19.52,10.1-20.73-.3-20.76-25.42-20.76-25.49Z" />
				<path #animatedPath class="st0"
					d="M242.02,380.04c-4.29,0-7.76-3.61-7.76-8.05s3.48-8.05,7.76-8.05h49.95c4.29,0,7.76,3.61,7.76,8.05s-3.48,8.05-7.76,8.05h-49.95Z" />
			</g>

			<!--Thinking Face-->
			<g id="_2964748157392" *ngIf="currentFace==='thinking'">
				<polygon #animatedPath class="st0"
					points="456.41 161.02 448.35 171.1 428.58 156.51 436.73 145.28 456.41 161.02" />
				<path #animatedPath class="st0"
					d="M453.34,123.88l-10.36,12.86,19.86,15.45,9.21-11.52s19.67,9,29.62-8.78c9.96-17.79-4.33-30.09-6.3-32.21,0,0-18.59-15.96-29.58-13.8,0,0-10.86-1.51-21.66,17.21l17.21,13.61s3.6-5.82,8.38-6.02,9.36,5.1,8.18,9.16-3.99,6.74-11.39,6.09-13.17-2.05-13.17-2.05h0Z" />
			</g>
			<g id="_2923223344320" *ngIf="currentFace==='thinking'">
				<polygon #animatedPath class="st0"
					points="427.22 113.49 428.41 123.12 410.19 126.09 408.43 115.81 427.22 113.49" />
				<path #animatedPath class="st0"
					d="M405.63,95.65l1.48,12.33,18.74-2.57-1.36-11s15.17-5.85,10.83-20.55c-4.34-14.69-18.46-13.47-20.63-13.52,0,0-18.34,1.62-22.95,8.67,0,0-6.51,5.05-2.11,20.69l16.36-2.11s-1.24-4.99,1.16-7.67c2.4-2.67,7.66-2.35,9.22.41,1.56,2.76,1.53,5.69-2.7,9.32-4.23,3.63-8.02,6.01-8.02,6.01h0Z" />
			</g>
			<g id="_2923223342064" *ngIf="currentFace==='thinking'">
				<ellipse class="st0" cx="231.45" cy="302.22" rx="20.16" ry="11.09" />
				<ellipse class="st0" cx="347.71" cy="302.22" rx="20.16" ry="11.09" />
				<path #animatedPath class="st0"
					d="M296.95,355.91c.32.32.67.61,1.05.85h0c.94.6,2.05.95,3.25.95,3.33,0,6.03-2.7,6.03-6.03,0-1.48-.54-2.84-1.43-3.89h0s0,0,0,0c-.59-.69-1.32-1.25-2.16-1.62-5.94-4.07-23.73-13.84-48.39-5.63-1.8.6-2.38.58-4.02.94-1.44.32-2.95,1.13-3.77,2.17h0s0,0,0,0c-.79,1.02-1.26,2.3-1.26,3.69,0,3.33,2.7,6.03,6.03,6.03,1.08,0,2.09-.28,2.96-.78h0s24.01-10.56,41.7,3.31Z" />
				<path class="st0"
					d="M202.65,277.47c-1.39-.45-2.16-1.94-1.71-3.33s1.94-2.16,3.33-1.71c.05.02,16.66,5.55,27.02-5.09,1.02-1.05,2.7-1.07,3.74-.05,1.05,1.02,1.07,2.7.05,3.74-12.69,13.02-32.38,6.46-32.44,6.44Z" />
				<path class="st0"
					d="M328.81,259.59c-1.37.52-2.9-.17-3.42-1.54s.17-2.9,1.54-3.42c.1-.04,34.47-13.37,54.48,7.35,1.01,1.05.98,2.73-.07,3.74-1.05,1.01-2.73.98-3.74-.07-17.54-18.17-48.68-6.1-48.77-6.06h0Z" />
			</g>
		</g>
	</svg>
</button>